import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { LazyComponent } from "../../FundPages/core/LazyComponent";
import "../../FundPages/core/LazyComponent.scss"

const ContentAreaBlock = React.lazy(() => import('../../FundPages/blocks/ContentAreaBlock'));
const HTMLBlock = React.lazy(() => import('../../FundPages/blocks/HtmlBlock'));
const VisualSectionBlock = React.lazy(() => import('../Components/VisualSectionBlock/VisualSectionBlock'));
const TabContentBlock = React.lazy(() => import('../Components/TabContentBlock/TabContentBlock'));
const PerformanceChartBlock = React.lazy(() => import('../Components/PerformanceChartBlock/PerformanceChartBlock'));
const HighchartBlock = React.lazy(() => import('../Components/HighchartBlock/HighchartBlock'));
const TextVideoBlock = React.lazy(() => import('../Components/TextVideoBlock/TextVideoBlock'));

//Bots
const isCrawler = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

const blockTypes = [
    {
        name: "ContentAreaBlock",
        tagName: "ve-contentareablock",
        component: ContentAreaBlock,
        LoadImmediately: false
    },
    {
        name: "HTMLBlock",
        tagName: "ve-htmlblock",
        component: HTMLBlock,
        LoadImmediately: false,
    },
    {
        name: "VisualSectionBlock",
        tagName: "ve-visualsectionucitsblock",
        component: VisualSectionBlock,
        LoadImmediately: false,
    },
    {
        name: "TabContentBlock",
        tagName: "ve-tabcontentucitsblock",
        component: TabContentBlock,
        LoadImmediately: false,
    },
    {
        name: "PerformanceChartBlock",
        tagName: "ve-performancechartucitsblock",
        component: PerformanceChartBlock,
        LoadImmediately: false,
    },
    {
        name: "HighchartBlock",
        tagName: "ve-performancechartucitsblock",
        component: HighchartBlock,
        LoadImmediately: false,
        template: "HighchartBlock"
    },
    {
        name: "TextVideoBlock",
        tagName: "ve-textvideoucitsblock",
        component: TextVideoBlock,
        LoadImmediately: false,
    }
]

export function processMarkup(rootElem = document) {
    //If it is a crawler, remove the blocks that are too slow to load.
    let blockTypesToRender = blockTypes;
    if (isCrawler) {
        blockTypesToRender = blockTypes.filter(block => {
            return typeof (block.IgnoreForCrawlers) == "undefined" || block.IgnoreForCrawlers == false;
        })
    }

    for (const block of blockTypesToRender) {
        var containers = rootElem.getElementsByTagName(block.tagName)
        if (block.template != null) {
            containers = Array.from(containers).filter(x => x.dataset.template == block.template)
        }
        for (const container of containers) {
            const root = createRoot(container);
            const { component, LoadImmediately } = block;
            root.render(
                <Suspense fallback={<div className="component-loading">Loading...</div>}>
                    <LazyComponent component={component} rootElement={container} loadImmediately={LoadImmediately} />
                </Suspense>
            );
        }
    }
}